import { Box, Container, Stack, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import PageNavigationCard from '../common/PageNavigationCard';
import { AdminPageDetails, PageDetails } from './config';
import { connect } from 'react-redux';
import { getUser, isUserAdmin, isUserSAMPowerUp, isUserSAMSuperUser } from '../Layout/utils';
import { SAM_POWER_USER_UP, SAM_SUPER_USER_UP } from '../common/constants/sam';
import { JobProcessingBanner } from './JobProcessingBanner';
import PortalPageHeader from '../common/PortalPageHeader';

class SAM extends Component {
  state = {
    id: 'studentAdvisorManagement',
    pageDetails: {},
    samPages: [],
    samAdminPages: [],
  };

  componentDidMount() {
    this.loadCurrentPageDetails();
    this.loadSubPages();
    this.loadAdminPages();
  }

  filterAccessibleContent = (pages, currentPageId) => {
    const user = getUser(this.props.user, this.props.impersonation);
    return Object.values(pages).filter((page) => {
      const isPage = page.id !== currentPageId;

      if (!page.required) return isPage;

      const isRequired = page.required.some((checker) => {
        switch (checker) {
          case SAM_POWER_USER_UP:
            return isUserSAMPowerUp(user) || isUserAdmin(user);
          case SAM_SUPER_USER_UP:
            return isUserSAMSuperUser(user) || isUserAdmin(user);
          default:
            return false;
        }
      });

      return isPage && isRequired;
    });
  };

  //θ(N) where N is the number of pages
  //Search for current page details and set in state
  loadCurrentPageDetails = (pages = PageDetails) => {
    const pageDetails = Object.values(pages).find((page) => page.id === this.state.id);
    this.setState({
      pageDetails,
    });
  };

  //θ(N) where N is the number of pages
  //Get all subpages and set in state
  loadSubPages = () => {
    this.setState({
      samPages: this.filterAccessibleContent(PageDetails, this.state.id),
    });
  };

  //θ(N) where N is the number of pages
  //Get all admin subpages and set in state
  loadAdminPages = () => {
    this.setState({
      samAdminPages: this.filterAccessibleContent(AdminPageDetails, this.state.id),
    });
  };

  render() {
    const id = this.state.id;

    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PortalPageHeader
              id={id}
              title={this.state.pageDetails?.title}
              banner={<JobProcessingBanner />}
              breadcrumbs={this.state.pageDetails.breadcrumbs}
            />

            <Box id={`${id}__box_wrapper`} className={'wrapper'}>
              <Typography
                id={`${id}__header_advisorTasks`}
                component="h3"
                className={!_.isEmpty(this.state.samAdminPages) ?? 'sr-only'}
              >
                Advisor Tasks
              </Typography>

              <Grid
                container
                spacing={2}
                alignItems="stretch"
                className="mb-6"
                id={`${id}__stack_advisorTasks_wrapper`}
              >
                {this.state.samPages.map((item, index) => {
                  return (
                    <Grid item lg={12} xl={6} id={`${id}__stack_advisorTasks_${index}`}>
                      <PageNavigationCard
                        url={this.state.pageDetails.url}
                        id={id}
                        subPage={item}
                        header={'h4'}
                      />
                    </Grid>
                  );
                })}
              </Grid>

              <Typography
                component="h3"
                className={!_.isEmpty(this.state.samAdminPages) ?? 'sr-only'}
              >
                Administrator Tasks
              </Typography>

              <Grid container spacing={2} className="mb-6" alignItems={'stretch'}>
                {this.state.samAdminPages.map((item) => {
                  return (
                    <Grid item lg={12} xl={6} alignItems={'stretch'}>
                      <PageNavigationCard
                        url={this.state.pageDetails.url}
                        id={id}
                        subPage={item}
                        header={'h4'}
                        cardClass="admin"
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AWSReducer.user,
    impersonation: state.impersonationReducer.impersonation,
  };
};

export default connect(mapStateToProps)(SAM);
